exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-checkbox-group--horizontal{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap}", "", {"version":3,"sources":["/Users/kuaiyin/Desktop/git.kuaiyin/vision-h5/node_modules/vant/es/checkbox-group/index.css"],"names":[],"mappings":"AAAA,gCAAgC,oBAAoB,qBAAqB,aAAa,uBAAuB,cAAc,CAAC","file":"index.css","sourcesContent":[".van-checkbox-group--horizontal{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/checkbox-group/index.css
// module id = 2uuz
// module chunks = 212